import type { FC } from "react"

import type { InventoryByProductWarehouse } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"
import { formatWarehouseLabel } from "@/utils/warehouse"

interface InventoryAdjustmentWarehouseLabelProps {
  warehouseInventory: InventoryByProductWarehouse
}

export const InventoryAdjustmentWarehouseLabel: FC<InventoryAdjustmentWarehouseLabelProps> = ({
  warehouseInventory,
}) => {
  const { warehouseArea, qtyOnHand, numPallets } = warehouseInventory
  if (!warehouseArea) return null
  return (
    <span>
      {formatWarehouseLabel(warehouseArea)}
      {qtyOnHand !== null && qtyOnHand !== undefined && (
        <span className='ml-1 text-gray-600'>
          ({numPallets} pallets / {formatNumber(qtyOnHand)} on hand)
        </span>
      )}
    </span>
  )
}
